import axios from "axios";
import { createContext } from "react";

const AIAssistantChatContext = createContext();

export const AIAssistantChatContextProvider = ({ children }) => {
  const initializeChat = (shortCode, model) => {
    const body = { shortCode };
    if (model) body.model = model;
    return axios.post("/api/ai/assistants/chat/initialize", body);
  };

  const getChat = (id) => {
    return axios.get(`/api/ai/assistants/chat/${id}`);
  };

  const addUserMessage = (id, text) => {
    return axios.post(`/api/ai/assistants/chat/${id}/add-user-message`, { text });
  };

  const addUserMessageParts = (id, parts) => {
    return axios.post(`/api/ai/assistants/chat/${id}/add-user-message`, { parts });
  };

  const startProcess = (id) => {
    return axios.post(`/api/ai/assistants/chat/${id}/start-process`);
  };

  const getChatStatus = (id) => {
    return axios.get(`/api/ai/assistants/chat/${id}/status`);
  };

  const getLastMessage = (id) => {
    return axios.get(`/api/ai/assistants/chat/${id}/last-message`);
  };

  const addToolResult = (id, toolCallId, toolName, result) => {
    return axios.post(`/api/ai/assistants/chat/${id}/add-tool-result`, {
      toolCallId,
      toolName,
      result,
    });
  };

  return (
    <AIAssistantChatContext.Provider
      value={{
        initializeChat,
        getChat,
        addUserMessage,
        addUserMessageParts,
        startProcess,
        getChatStatus,
        getLastMessage,
        addToolResult,
      }}
    >
      {children}
    </AIAssistantChatContext.Provider>
  );
};

export default AIAssistantChatContext;
